// Мелкие помощники, общие для экранов (даты в формате оболочки ДД.ММ.ГГ).
export function fmt(d?: string | null): string {
  if (!d) return '';
  const p = d.split('-');
  return p[2] + '.' + p[1] + '.' + p[0].slice(2);
}

/** «15.04.26» / «15.04.2026» / ISO → ISO; пусто → null; не разобрано → undefined */
export function parseDate(s: string): string | null | undefined {
  s = (s || '').trim();
  if (!s) return null;
  const m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{2,4})$/);
  if (m) {
    let y = +m[3];
    if (y < 100) y += 2000;
    return y + '-' + String(m[2]).padStart(2, '0') + '-' + String(m[1]).padStart(2, '0');
  }
  return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : undefined;
}

/** Цвет ячейки по типу этажа: известные — свои, прочие — оттенок из названия */
/** Типы этажа — системный набор (решение владельца 2026-09-12), тот же список,
    что `api.TIPY_ETAZHA` на сервере: менять вместе. Сервер отвергает другие значения. */
export const TIPY_ETAZHA = ['Первый', 'Типовой', 'Технический', 'Кровля', 'Ниже 0,000', 'Исключение'];
/** тип «Исключение» = этаж вне расчёта (владелец, #24 2026-09-12): все его задачи вне модели */
export const TIP_ISKL = 'Исключение';

export function tipColor(tip?: string | null): { bg: string; bd: string } | null {
  const t = (tip || '').trim();
  if (!t) return null;
  const KNOWN: Record<string, [string, string]> = {
    'Первый': ['#e1f4e6', '#12b76a'], 'Типовой': ['#e8effc', '#7ba3f7'],
    'Кровля': ['#ece4fa', '#7c3aed'], 'Технический': ['#e9edf2', '#8fa0b5'], 'Исключение': ['#fde3e1', '#d92d20'],
  };
  if (KNOWN[t]) return { bg: KNOWN[t][0], bd: KNOWN[t][1] };
  let h = 0;
  for (let i = 0; i < t.length; i++) h = (h * 31 + t.charCodeAt(i)) % 360;
  return { bg: 'hsl(' + h + ',65%,93%)', bd: 'hsl(' + h + ',55%,55%)' };
}

/** Контуры работы строкой → список значений.
    У работы контуров может быть несколько через запятую, но само значение тоже
    бывает с запятой («Ниже 0,000») — из-за наивного split такая работа не
    находилась фильтром (2026-09-09). Поэтому сначала пробуем строку целиком:
    если она есть в списке известных значений (или список не передан) — это одно
    значение; разбиваем только когда все куски оказались известными. */
export function kontury(s?: string | null, izvestnye?: string[]): string[] {
  const t = String(s ?? '').trim();
  if (!t) return [];
  // сверка без учёта регистра (#43, 2026-09-13): у работы «этаж», в «Списках» — «Этаж»;
  // наружу отдаём написание из списка, чтобы галочки в окне контуров совпадали
  const kanon = (x: string) => (izvestnye || []).find(z => z.toLowerCase() === x.toLowerCase());
  if (izvestnye && kanon(t)) return [kanon(t)!];
  const chasti = t.split(',').map(x => x.trim()).filter(Boolean);
  if (chasti.length < 2) return [t];
  if (izvestnye && !chasti.every(x => kanon(x))) return [t];
  return izvestnye ? chasti.map(x => kanon(x)!) : chasti;
}

/** Мягкие переносы по слогам для русских подписей в узких столбцах (2026-09-14).
 *  Браузер переносит слово только в этих местах и ставит дефис — одинаково везде;
 *  встроенный `hyphens:auto` для русского есть не во всех браузерах, а перенос
 *  «в любом месте» режет слово без дефиса («кронштейно|в»). Правила — классические
 *  упрощённые: не отрывать й/ь/ъ, делить между гласными и по стыку согласных. */
export function slogi(s: string): string {
  const vse = '[абвгдеёжзийклмнопрстуфхцчшщъыьэюя]', gl = '[аеёиоуыэюя]',
    sg = '[бвгджзклмнпрстфхцчшщ]', zn = '[йъь]', shy = '\u00AD';
  const pravila = [
    new RegExp('(' + zn + ')(' + vse + vse + ')', 'gi'),
    new RegExp('(' + gl + ')(' + gl + vse + ')', 'gi'),
    new RegExp('(' + gl + sg + ')(' + sg + gl + ')', 'gi'),
    new RegExp('(' + sg + gl + ')(' + sg + gl + ')', 'gi'),
    new RegExp('(' + gl + sg + ')(' + sg + sg + gl + ')', 'gi'),
    new RegExp('(' + gl + sg + sg + ')(' + sg + sg + gl + ')', 'gi'),
  ];
  return s.split(' ').map(w => {
    if (w.length < 7) return w;
    let r = w;
    for (const re of pravila) r = r.replace(re, '$1' + shy + '$2');
    return r;
  }).join(' ');
}
